import {Component, Input, OnInit} from "@angular/core";
import {Project} from "../../../services/model/projects.model";
import {ProjectService} from "../../../services/project.service";
import {ActivatedRoute} from "@angular/router";
import {ConfirmComponent} from "../../../dialogs/confirm/confirm.component";
import {MatDialog, MatDialogRef} from "@angular/material";
import {NotificationService} from "../../../services/notification.service";
import {CredentialDialogComponent} from "../../../dialogs/credential/credential.component";
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-credentials',
    templateUrl: './credentials.component.html',
})
export class CredentialsComponent implements OnInit{

    items: any;
    id: string;
    env = environment;
    dialogRef: MatDialogRef<ConfirmComponent>;
    editRef: MatDialogRef<CredentialDialogComponent>;
    @Input('project') project: Project;

    constructor(
        private projectServ: ProjectService,
        private activeR: ActivatedRoute,
        public dialog: MatDialog,
        private notifServ: NotificationService,
    ){
        this.id = this.activeR.snapshot.params['id'];
    }

    ngOnInit(){

        this.items = this.projectServ.getProjectCredentials(this.id).map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Project;
                const key = a.payload.doc.id;
                return { key, ...data };
            });
        });

    }

    editItem(status: boolean, item?: any){
        this.editRef = this.dialog.open(CredentialDialogComponent, {width: this.env.dialogs.width});
        this.editRef.componentInstance.item = status ? item : {};
        this.editRef.componentInstance.id = this.id;
        this.editRef.componentInstance.is_new = !status;

        this.editRef.afterClosed().subscribe(result => {
            // TODO make sure the model does not change the old values
            if(result) {
            } else {
            }
        });
    }

    deleteCredential(key: string){
        this.projectServ.deleteCredential(this.id, key).then(
            r => {
                this.notifServ.sendSuccess( 'Credential has been deleted');
            }
        )
    }


    openDelete(key: string){
        console.log(key);
        this.dialogRef = this.dialog.open(ConfirmComponent, {});
        this.dialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete this credential?';

        this.dialogRef.afterClosed().subscribe(result => {
            if(result) {
                this.deleteCredential(key);
            } else {
            }
        });
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/credentials/credentials.component.ts